import { calculatePointerPosition } from '../utils/calculatePointerPosition';

export const getNormalizedPosition = (value: string, low: number, high: number) => {
  const normalizedValue = parseFloat(value.replace(/[<|>]/, ''));
  const position = calculatePointerPosition(normalizedValue, low, high);

  return position;
};
